import React from 'react';

export const collapsedSVG = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.26902 7.29278C9.18373 7.38564 9.11608 7.49591 9.06992 7.61728C9.02376 7.73864 9 7.86873 9 8.0001C9 8.13147 9.02376 8.26156 9.06992 8.38292C9.11608 8.50429 9.18373 8.61455 9.26902 8.70742L12.0744 11.7647C12.1317 11.8272 12.1639 11.912 12.1639 12.0004C12.1639 12.0887 12.1317 12.1735 12.0744 12.236L9.26902 15.2926C9.09685 15.4801 9.00009 15.7345 9.00003 15.9997C8.99997 16.2649 9.09662 16.5193 9.26871 16.7069C9.4408 16.8945 9.67424 16.9999 9.91767 17C10.1611 17.0001 10.3946 16.8948 10.5668 16.7073L13.3727 13.65C13.5716 13.4333 13.7293 13.1761 13.837 12.893C13.9446 12.6099 14 12.3064 14 12C14 11.6936 13.9446 11.3902 13.837 11.1071C13.7293 10.8239 13.5716 10.5667 13.3727 10.3501L10.5668 7.29278C10.3946 7.10531 10.1612 7 9.91789 7C9.67452 7 9.44113 7.10531 9.26902 7.29278Z"
			fill="#5A5E90"
		/>
	</svg>
);

export const expandedSVG = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.2072 9.76902C16.1144 9.68373 16.0041 9.61608 15.8827 9.56992C15.7614 9.52376 15.6313 9.5 15.4999 9.5C15.3685 9.5 15.2384 9.52376 15.1171 9.56992C14.9957 9.61608 14.8854 9.68373 14.7926 9.76902L11.7353 12.5744C11.6728 12.6317 11.588 12.6639 11.4996 12.6639C11.4113 12.6639 11.3265 12.6317 11.264 12.5744L8.20738 9.76902C8.01988 9.59685 7.76553 9.50009 7.5003 9.50003C7.23507 9.49997 6.98067 9.59662 6.79308 9.76871C6.60549 9.9408 6.50006 10.1742 6.5 10.4177C6.49994 10.6611 6.60524 10.8946 6.79275 11.0668L9.85002 13.8727C10.0667 14.0716 10.3239 14.2293 10.607 14.337C10.8901 14.4446 11.1936 14.5 11.5 14.5C11.8064 14.5 12.1098 14.4446 12.3929 14.337C12.6761 14.2293 12.9333 14.0716 13.1499 13.8727L16.2072 11.0668C16.3947 10.8946 16.5 10.6612 16.5 10.4179C16.5 10.1745 16.3947 9.94113 16.2072 9.76902Z"
			fill="#5A5E90"
		/>
	</svg>
);

export const downloadSVG = (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1485_27461)">
			<path
				d="M11.75 12H0.25C0.11 12 0 11.89 0 11.75C0 11.61 0.11 11.5 0.25 11.5H11.75C11.89 11.5 12 11.61 12 11.75C12 11.89 11.89 12 11.75 12ZM7.335 9.955L10.615 6.28C11 5.895 11.105 5.34 10.9 4.84C10.69 4.335 10.22 4.015 9.675 4.015H8.505V1.735C8.505 0.775 7.72 0 6.75 0H5.255C4.29 0 3.5 0.78 3.5 1.735V4.01H2.335C1.785 4.01 1.315 4.33 1.11 4.835C0.905 5.34 1.015 5.895 1.39 6.275L4.685 9.965C5.05 10.33 5.525 10.51 6.005 10.51C6.485 10.51 6.97 10.325 7.34 9.955H7.335ZM3.75 4.515C3.815 4.515 3.88 4.49 3.925 4.44C3.97 4.39 4 4.33 4 4.265V1.735C4 1.055 4.56 0.5 5.25 0.5H6.745C7.435 0.5 8 1.055 8 1.735V4.26C8 4.4 8.11 4.51 8.25 4.51H9.67C10.08 4.51 10.335 4.78 10.435 5.025C10.535 5.275 10.54 5.64 10.255 5.93C10.255 5.93 10.25 5.935 10.245 5.94L6.97 9.61C6.435 10.145 5.565 10.145 5.04 9.62L1.745 5.93C1.455 5.64 1.46 5.275 1.565 5.025C1.665 4.775 1.92 4.51 2.33 4.51H3.75V4.515Z"
				fill="#2424EC"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1485_27461">
				<rect width="12" height="12" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
